import fontResizeEventListener from '../components/helpers/fontResizeEventListener'
import imageEventListener from '../components/helpers/imageEventListener'
import spacingEventListener from '../components/helpers/spacingEventListener'
import textSpacingEventListener from '../components/helpers/textSpacingEventListener'
import DEFAULTS from './constants/defaults'
import initIframe from './iframe/initIframe'
import { loadPageData } from './loadPageData'
import initModalForm from './modal/initModalForm'
import initModalPhoto from './modal/initModalPhoto'
import initExtraSettings from './sidebar/initExtraSettings'
import initSidebar from './sidebar/initSidebar'
import initSnippetsSidebarLeft from './sidebarLeft/initSnippetsSidebarLeft'
import initTopbar from './topbar/initTopbar'
import generateId from './utils/generateId'

const parseData = (result) => {
  const data = result.data.reduce((acc, el) => {
    if (el.key) acc[el.key] = el
    return acc
  }, {})

  return data
}

export default async function init(target, config) {
  const self = this
  self.element = target
  self.options = $.extend({}, DEFAULTS, config)

  self.options.locale =
    self.options.lang !== 'en'
      ? self.options[`locale${self.options.lang}`]
      : self.options.locale

  initIframe.call(self)
  initSidebar.call(self)
  initSnippetsSidebarLeft.call(self)

  initExtraSettings.call(self)

  self.id = generateId()
  window.KEditor.instances[self.id] = self

  const waitCKEDITOR = setInterval(() => {
    if (self.iframeWindow.window.CKEDITOR) {
      clearInterval(waitCKEDITOR)
      const fetchData = async () => {
        try {
          const result = await $.ajax({
            url: self.options.apiSaveContent,
            type: 'GET',
            dataType: 'json',
            headers: {
              Authorization: self.options.accessToken,
            },
            contentType: 'application/json; charset=utf-8',
          })

          const data = parseData(result)

          loadPageData.apply(self, [data])
        } catch (error) {
          console.log(error)
          window.location.href = self.options.redirectUrl
        } finally {
          initTopbar.call(self)
          initModalForm({ page: this, keditor: self, form: null })
          initModalPhoto.call(this)

          const currentWidth = self.options.widthLaptop
          fontResizeEventListener(currentWidth, self)
          spacingEventListener(currentWidth, self)
          imageEventListener(currentWidth, self)
          textSpacingEventListener(currentWidth, self, 'line-height')
          textSpacingEventListener(currentWidth, self, 'letter-spacing')

          if (typeof self.options.onReady === 'function') {
            self.options.onReady.call(self)
          }
        }
      }

      fetchData()
    }
  }, 100 /* milli */)
}
